module.exports = __webpack_public_path__ + "img/img17.6464ba01.png";